module.exports = __webpack_public_path__ + "static/img/reyzarConceeptPic2.8bea802.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/reyzarConceeptPic2.png
// module id = V3qR
// module chunks = 0